import { Box, Typography } from "@mui/material";
import InPressArticle from "@/src/components/journal-site/home/in-press-articles/in-press-article/in-press-article";
import SectionHeading from "@/src/components/common/broadsheet/section-heading";
import MetaLine from "@/src/components/common/broadsheet/meta-line";
import { hairlineTop } from "@/src/components/common/broadsheet/tokens";
import InPressProps from "@/src/_types/in-press-props";
import VISUALLY_HIDDEN from "@/src/utils/visually-hidden";

const InPressArticles = (props: InPressProps) => {
  const count = props.articles?.length ?? 0;

  if (count === 0) return null;

  return (
    <Box component="section">
      {props.hideHeading ? (
        <Typography component="h2" sx={VISUALLY_HIDDEN}>
          {props.title}
        </Typography>
      ) : (
        <SectionHeading title={props.title} component="h2" />
      )}
      <MetaLine
        sx={{ mt: props.hideHeading ? 0.125 : -0.25, mb: 0.5 }}
        items={[`${count} article${count === 1 ? "" : "s"} ahead of print`]}
      />
      {(props.articles ?? []).map((article, index) => (
        <Box key={article.id ?? index} sx={{ py: 0.75, ...hairlineTop }}>
          <InPressArticle article={article} number={index + 1} />
        </Box>
      ))}
    </Box>
  );
};

export default InPressArticles;
